import SubCondition from "./SubCondition";
import React, { useContext } from "react";
import { RulesContext } from "../../RulesContext";
import Button from "Components/DesignSystem/Button/Button";
import { Add } from "Components/DesignSystem/Iconography/Icons";

const Condition = ({ element, position, DragHandle, rule, rootPosition }) => {
  const { ruleDispatch, ruleState } = useContext(RulesContext);
  return (
    <div className="tw-rounded-lg tw-border tw-border-edge tw-bg-surface-sunken tw-py-6 tw-px-2">
      <span className="drag-icon">{rule.length > 1 && <DragHandle />}</span>
      <div className="">
        <SubCondition {...{ element, position, rule,}} />
        {/* DS Button (okf/rules § 4.5): tertiary is the quiet accent action, and
            tertiary-on-a-sunken-ground is the look every dialog footer ships (§ 85
            onward). The DS `Add` glyph replaces the bespoke boxed-plus
            (AddIconWithBorder, fixed 40px, baked paints). Same testid, same
            dispatch. */}
        <Button
          variant="tertiary"
          size="sm"
          icon={<Add size={16} aria-hidden="true" />}
          iconSize="small"
          data-testid="rule-condition-add-btn"
          onClick={() => { ruleDispatch({ type: "ADD_NESTED_CONDITION", position: position,});}}
        >
          Add Condition
        </Button>
      </div>
    </div>
  );
};
export default Condition;